"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import * as Aria from 'react-aria-components';
import { IllustratedMessage } from '../IllustratedMessage/IllustratedMessage.mjs';
import styles from './FileDropZone.module.scss.mjs';
import clsx from 'clsx';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { addAwaitedArrayBuffer } from '../../../../core/src/file.mjs';

const FileDropZone = flowComponent(
  "FileDropZone",
  (props) => {
    const {
      multiple,
      accept,
      className,
      onChange: onChangeDropZone,
      children,
      name
    } = props;
    const fileFieldRef = useRef(null);
    const rootClassName = clsx(styles.fileDropZone, className);
    const propsContext = {
      FileField: {
        name,
        onChange: onChangeDropZone,
        ref: fileFieldRef,
        accept,
        multiple,
        Button: { variant: "outline", color: "dark" }
      }
    };
    const onDropHandler = async (event) => {
      const fileDropItems = event.items.filter(
        (file) => file.kind === "file"
      );
      const files = await Promise.all(
        fileDropItems.filter((f) => !accept || accept?.includes(f.type)).map(async (f) => {
          const file = await f.getFile();
          return await addAwaitedArrayBuffer(file);
        })
      );
      if (files.length > 0) {
        const fileTransfer = new DataTransfer();
        for (const file of multiple ? files : [files[0]]) {
          if (file) {
            fileTransfer.items.add(file);
          }
        }
        onChangeDropZone?.(fileTransfer.files);
        if (fileFieldRef.current) {
          fileFieldRef.current.files = fileTransfer.files;
        }
      }
    };
    return /* @__PURE__ */ jsx(Aria.DropZone, { className: rootClassName, onDrop: onDropHandler, children: /* @__PURE__ */ jsx(IllustratedMessage, { color: "dark", children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, mergeInParentContext: true, children }) }) });
  }
);

export { FileDropZone, FileDropZone as default };
//# sourceMappingURL=FileDropZone.mjs.map
